<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">manage purchase order</small>
      </legend>
      <div></div>
      <div>
        <div class="purchaseLoaders">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color:blue"></i>loadig purchaseorders...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemPurchaseorders"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'Action'">
              <button
                type="submit"
                class="btn btn-primary btn-sm btn-rounded purchaseorder_id"
                @click="viewPurchaseorder(props.row.id)"
              >
                <i class="fa fa-plus"></i> print order
              </button>
            </span>
            <span v-else-if="props.column.field === 'Received'">
              <span v-if="props.row.received === 0">
                <button
               type="submit"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewOrder(props.row.id)"
              >
                <i class="fa fa-plus"></i> Receive good
              </button>

              </span>
                <span v-else-if="props.row.received === 1">
                <button class="btn btn-success btn-sm btn-rounded">
                  <i class="fa fa-check"></i> RECEIVED
                </button>
              </span>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Purchaseorder no",
          field: "purchase_order_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod number"
          }
        },
        {
          label: "order date",
          field: "purchase_order_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy" // outputs Mar 16th 2018
        },
        {
          label: "Grand total",
          field: "grand_total",
          type: "text"
        },
         {
          label: "Action",
          field: "Action",
          width: "100px",
          html: true
        },
        {
          label: "Received",
          field: "Received",
          width: "100px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadPurchaseorder();
  },
  computed: {
    ...mapGetters(["systemPurchaseorders"])
  },
  methods: {
    ...mapActions(["loadPurchaseorder", "viewPurchaseorder", "viewOrder"])
  }
};
</script>


// WEBPACK FOOTER //
// src/purchaseorders/managepurchaseorders.vue